export enum AdTypeEnum {
    product = 1,
    service = 2
}